"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.NoteAddOutlineSVG = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _react = _interopRequireDefault(require("react"));
var _Icon = require("../Icon");
var _excluded = ["children"];
var innerSvg = '<path d="M29.04 19.88l-.23-.14C27.76 19.13 26 18.11 26 14V6a2 2 0 00-2-2H4a2 2 0 00-2 2v20a2 2 0 002 2h20a2 2 0 002-2v-2h2a2 2 0 002-2v-.42a1.97 1.97 0 00-.96-1.7zM24 26H4v-4.92a9.44 9.44 0 003.63 2.85A.94.94 0 008 24h16zm4-4H8.21A7.59 7.59 0 014 15V6h20v8c0 3.22.96 5.03 2 6.11a7.49 7.49 0 001.8 1.36l.2.11z"/><path d="M18 13h-3v-3a1 1 0 00-2 0v3h-3a1 1 0 000 2h3v3a1 1 0 002 0v-3h3a1 1 0 000-2z"/>';
var NoteAddOutlineSVG = function NoteAddOutlineSVG(_ref) {
  var children = _ref.children,
    rest = (0, _objectWithoutProperties2.default)(_ref, _excluded);
  return /*#__PURE__*/_react.default.createElement("svg", (0, _extends2.default)({
    viewBox: "0 0 32 32"
  }, rest), children, /*#__PURE__*/_react.default.createElement("g", {
    stroke: "none",
    dangerouslySetInnerHTML: {
      __html: innerSvg
    }
  }));
};
exports.NoteAddOutlineSVG = NoteAddOutlineSVG;
NoteAddOutlineSVG.propTypes = process.env.NODE_ENV !== "production" ? {
  children: _propTypes.default.node
} : {};
var _default = (0, _Icon.withIcon)(NoteAddOutlineSVG);
exports.default = _default;